import React from "react";
import styled, { css } from "styled-components";
import { MANAGE_REPAYMENTS_INCREASE_ROUTE as MANAGE_REPAYMENTS_ROUTE } from "./route.constants";
import { DoubleRepayments } from "./components/doubleRepayments";
import { PayHigherAmount } from "./components/payHigherAmount";
import { ManageRepaymentsOption } from "../../manageRepaymentsOption";
import { useAccount } from "../../../../hooks/client";
import { INCREASE_PAYMENT_STATES } from "../../../../constants/commonConstants";
import { MakeExtraRepayments } from "./components/MakeExtraRepayments/makeExtraRepayments";

const Wrapper = styled.div(({ theme }) => css`
  .increase-title, .decrease-title {
    text-transform: ${theme.fonts.headingCase};
    font-size: 18px;
    color: ${theme.palette.status.goodAlt};
    font-weight: ${theme.fonts.headingWeight};
  }

  .decrease-title {
    padding-top: 35px;
  }

  li {
    padding: 5px 0;
  }

  .decrease-info {
    padding: 15px 0 15px;
  }

  .chat-manage-repayments {
    color: ${theme.palette.status.goodAlt};
  }
`);

export const ManageRepaymentsIncrease = ({ accountId }) => {
  const { increaseRepayments } = useAccount(accountId) || {};

  return (
    <Wrapper>
      <div className="increase-title">Increase My Repayments</div>
      <ul>
        <li>
          <ManageRepaymentsOption
            accountId={accountId}
            title="Make an extra repayment"
            subRoute={MANAGE_REPAYMENTS_ROUTE.INCREASE_EXTRA}
            changeTitleColourWhenActive={true}
          >
            <MakeExtraRepayments accountId={accountId} />
          </ManageRepaymentsOption>
        </li>
        {increaseRepayments !==
          INCREASE_PAYMENT_STATES.SCHEDULE_LESS_THAN_TWO && (
          <li>
            <ManageRepaymentsOption
              accountId={accountId}
              title="Double the next repayment"
              subRoute={MANAGE_REPAYMENTS_ROUTE.INCREASE_DOUBLE}
              changeTitleColourWhenActive={true}
            >
              <DoubleRepayments accountId={accountId} />
            </ManageRepaymentsOption>
          </li>
        )}
        <li>
          <ManageRepaymentsOption
            accountId={accountId}
            title="Pay a higher amount for the rest of the loan"
            subRoute={MANAGE_REPAYMENTS_ROUTE.INCREASE_HIGHER}
            changeTitleColourWhenActive={true}
          >
            <PayHigherAmount accountId={accountId} />
          </ManageRepaymentsOption>
        </li>
      </ul>
    </Wrapper>
  );
};